import React from 'react';
import {
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Icon,
} from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import { LINK_STATUSES, type LinkStatus } from '../../types/link';

export interface FilterValue {
  search: string;
  status: LinkStatus | 'all';
}

interface Props {
  value: FilterValue;
  onChange: (next: FilterValue) => void;
}

export const LinkFilters: React.FC<Props> = ({ value, onChange }) => (
  <HStack spacing={3} flexWrap="wrap">
    <InputGroup maxW="320px">
      <InputLeftElement pointerEvents="none">
        <Icon as={FiSearch} color="gray.400" />
      </InputLeftElement>
      <Input
        placeholder="Search code, destination, campaign…"
        value={value.search}
        bg="white"
        onChange={(e) => onChange({ ...value, search: e.target.value })}
      />
    </InputGroup>
    <Select
      maxW="160px"
      bg="white"
      value={value.status}
      onChange={(e) => onChange({ ...value, status: e.target.value as FilterValue['status'] })}
    >
      <option value="all">All statuses</option>
      {LINK_STATUSES.map((s) => (
        <option key={s} value={s}>
          {s[0].toUpperCase() + s.slice(1)}
        </option>
      ))}
    </Select>
    {/* SL_009: Channel filter removed — Smart Links have no channel dimension. */}
  </HStack>
);
